import UnscheduledDetails from './UnscheduledDetails';

export default UnscheduledDetails;
